import { Shimmer } from "@repo/ui";
import { useTheme } from "@repo/tokens";
import styles from "./FlashcardShimmer.module.scss";

const TEXT_LINES = 10;
const FOOTER_ICONS = 4;

export function FlashcardShimmer() {
  const { theme } = useTheme();
  const base = theme.colors.neutral[90];
  const highlight = theme.colors.neutral[80];

  return (
    <div className={styles.container}>
      <div className={styles.scroll}>
        <Shimmer
          variant="image"
          aspectRatio={16 / 9}
          shape="rounded"
          baseColor={base}
          highlightColor={highlight}
        />
        <div className={styles.lines}>
          {Array.from({ length: TEXT_LINES }).map((_, index) => (
            <Shimmer
              key={index}
              variant="textLine"
              shape="rounded"
              style={index === 0 ? { height: 24 } : undefined}
              baseColor={base}
              highlightColor={highlight}
            />
          ))}
        </div>
      </div>
      <div className={styles.footer}>
        <div className={styles.footerIcons}>
          {Array.from({ length: FOOTER_ICONS }).map((_, index) => (
            <Shimmer
              key={`icon-${index}`}
              variant="card"
              width={24}
              height={24}
              shape="rounded"
              baseColor={base}
              highlightColor={highlight}
            />
          ))}
        </div>
        <Shimmer
          variant="textLine"
          width={50}
          shape="rounded"
          baseColor={base}
          highlightColor={highlight}
        />
        <Shimmer
          variant="card"
          width={24}
          height={24}
          shape="rounded"
          baseColor={base}
          highlightColor={highlight}
        />
      </div>
    </div>
  );
}
